module.exports = __webpack_public_path__ + "img/file-icon_pptx.c05e1e6c.svg";